import React from "react";
import Slider from "react-slick";
import "./sleepCarousel.css";

const SleepSpecialistsCarousel = ({ data }) => {
 
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", right: "-40px", zIndex: 10 }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", left: "-40px", zIndex: 10 }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        infinite: true,
        centerMode: true,
        centerPadding: "0", 
        slidesToShow: 3, 
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,  
                settings: {
                    slidesToShow: 2,
                    arrows: true,
                },
            },
            {
                breakpoint: 640,  
                settings: {
                    slidesToShow: 1,
                    arrows: false, 
                },
            },
        ],
    };

    return (
        <div className="embla sleep-slider">
            <div className="embla__viewport">
                <Slider {...settings} className="embla__container">
                    {Object.entries(data).map(([key, item], index) => (
                        <div className="embla__slide" key={key}>
                            <div className="sleep-card">
                                <img src={item.img} alt={item.title} />
                                <h3>{item.title}</h3>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default SleepSpecialistsCarousel;
